module.exports = __webpack_public_path__ + "static/logo-bc57a9d22be36d1f5533f7b8776a8e32.jpg";